<!-- <app-data-table [columns]="cols" [data]="systems" [title]="title"></app-data-table> -->


<ng-container>
    <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()"
         [isDeletable]="'/master/ship' | hasPermission: 'Delete'"  [showAddButton]="'/master/ship' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/ship' | hasPermission: 'Edit'" [title]="title" (onAdd)="addSystem()" (onLazyLoadData)="getSystem($event)" [isView]="'/master/ship' | hasPermission: 'View'" [totalRecords]="totalRecords" (viewEventRow)="viewSystem($event)" [title]="title" (onAdd)="addSystem()" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords"
        (editEventRow)="updateSystem($event)" (deleteEventRow)="showDeletePopup($event)" [url]="'/master/ship/'">
    </app-data-table>
</ng-container>

<app-reusable-dialog
  [(visible)]="showDialog"
  [config]="addDialogConfig"
  [initialData]="{}"
  [viewMode]="false"
  (onSubmit)="onSubmitAdd($event)"
  (onCancel)="onCancelAdd()"
  (onClose)="onCloseAdd()"
></app-reusable-dialog>


<app-reusable-dialog
  [(visible)]="isUpdatedialog"
  [config]="updateDialogConfig"
  [initialData]="selectedShipData"
  [viewMode]="viewMode"
  (onSubmit)="onSubmitUpdate($event)"
  (onCancel)="onCancelUpdate()"
  (onClose)="onCloseUpdate()"
></app-reusable-dialog>


<p-dialog header="Delete Ship" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
    <div class="delete-dialog mt-3">
        <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete ship ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
        </p-button>
    </div>
</p-dialog>